<template>
  <div class="container-fluid" style="padding:0; margin:0;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>


// WEBPACK FOOTER //
// src/App.vue